import React from 'react'
import { Rate as AntRate } from 'antd'
import { RateProps as AntRateProps } from 'antd/lib/rate'

type Props = AntRateProps

export const Rate: React.FC<Props> = ({
  allowClear,
  allowHalf,
  className,
  count,
  disabled,
  value,
  onChange,
  style,
  tooltips,
  character
}) => {
  const controlledProps = {
    ...(value !== undefined && { value })
  }
  return (
    <AntRate
      allowHalf={allowHalf}
      allowClear={allowClear}
      className={className}
      count={count}
      disabled={disabled}
      onChange={onChange}
      style={style}
      tooltips={tooltips}
      character={character}
      {...controlledProps}
    />
  )
}
